// extracted by mini-css-extract-plugin
module.exports = {"trailersWrapper":"qn","trailerHeader":"qo","trailers":"qp","trailer":"qq","imgWrapper":"qr","playWrapper":"qs","playImg":"qt","title":"qu","slipnslideArrow":"qv"};